const labelCls = "_275l1raxzjq";
const chevron = "_275cbzp6gl";
const linkCls = "_275lu3y9pt";
const stateWrapperCls = "_275snfktq3";
const iconWrapper = "_275i76kd4g";
const throbberWrapperCls = "_275t1v0owf3";
const throbberCls = "_275tgzmkxg";

export { chevron, iconWrapper, labelCls, linkCls, stateWrapperCls, throbberCls, throbberWrapperCls };
import "./atom.link.style.linaria.module.css";
//# sourceMappingURL=atom.link.style.js.map
